export default __webpack_public_path__ + "static/media/logo-sm.1e0fadd5.svg";